import LoadingData from "components/Loading/LoadingData";
import TableStoreNotasFiscais from "../components/table-store-notas-fiscais";
import { Grid } from "@material-ui/core";

export default function NotasFiscaisView({
  showCardNotaFiscal,
  cancelLoading,
  storeNotasFiscais,
  pesquisandoNotasFiscais,
  periodoNotasFiscaisTituloLabel,
  handleStopSearching,
}) {
  return (
    <>
      {showCardNotaFiscal &&
        !cancelLoading &&
        storeNotasFiscais &&
        !pesquisandoNotasFiscais && (
          <TableStoreNotasFiscais
            dataTable={storeNotasFiscais}
            labelDias={periodoNotasFiscaisTituloLabel}
          />
        )}
      {pesquisandoNotasFiscais && (
        <Grid item xs={12}>
          <LoadingData
            searching={pesquisandoNotasFiscais}
            label="Buscando Notas Fiscais..."
            onClick={() => handleStopSearching()}
          />
        </Grid>
      )}
    </>
  );
}
